import { render } from "./DeleteRecord.vue?vue&type=template&id=7980fc6a&scoped=true"
import script from "./DeleteRecord.vue?vue&type=script&lang=js"
export * from "./DeleteRecord.vue?vue&type=script&lang=js"

import "@/components/modal-responsive.css?vue&type=style&index=0&id=7980fc6a&scoped=true&lang=css&external"
import "./DeleteRecord.vue?vue&type=style&index=1&id=7980fc6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7980fc6a"]])

export default __exports__